// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__OJvKo","calendarButtons":"ClockData_calendarButtons__2unDy"};